import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';
import {
  AutoLoginPartialRoutesGuard,
  OidcSecurityService,
} from 'angular-auth-oidc-client';
import { Role } from '../enums/role.enum';
import { LOGIN_METHOD_KEY, LoginMethod } from '../enums/login-method.enum';

export const customAuthGuard = async (roles?: Role[]) => {
    const router = inject(Router);
    const authService = inject(AuthService);
    const oidcSecurityService = inject(OidcSecurityService);
    const autoLoginPartialRoutesGuard = inject(AutoLoginPartialRoutesGuard);

    const loginMethod = localStorage.getItem(LOGIN_METHOD_KEY);
    let authToken: string | null = null;

    if (loginMethod === LoginMethod.IAM) {
        authToken = await firstValueFrom(oidcSecurityService.getAccessToken());
    } else if (loginMethod === LoginMethod.Identity) {
        authToken = authService.identityUser()?.token ?? null;
    }

    if (!authToken) {
        return router.createUrlTree(['/auth']);
    }

    const userRoles: Role[] = (authService.identityUser()?.roles as Role[]);

    if (loginMethod === LoginMethod.IAM) {
        return autoLoginPartialRoutesGuard.canActivate(
            {} as ActivatedRouteSnapshot,
            {} as RouterStateSnapshot
        );
    } else if (loginMethod === LoginMethod.Identity) {
        let user = authService.identityUser();

        if (!user) user = await firstValueFrom(authService.autoLogin());

        if (!user) return router.createUrlTree(['/auth']);

        if (roles == undefined || roles == null || user.isSuperAdmin)
            return true;

        return roles?.some(role => userRoles.includes(role)) ?? false;
    } else {
        return router.createUrlTree(['/auth']);
    }
};
